/**
 * Lightweight analytics for Sprint 1 PiP rollout.
 * Ships to console (dev) + window.dataLayer (production analytics tools can
 * consume). No third-party SDK dependency — keeps the beta clean.
 */
export function track(event, props = {}) {
  const payload = {
    event,
    ts: new Date().toISOString(),
    ...props,
  };
  try {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }
  } catch (e) {
    /* ignore */
  }
  // Also mirror to console in dev so we can see events immediately.
  // eslint-disable-next-line no-console
  console.log("[sch]", event, props);
}

export const PIP_EVENTS = {
  POP_OUT_CLICKED: "pip_pop_out_clicked",
  PIP_OPENED: "pip_opened",
  PIP_OPEN_FAILED: "pip_open_failed",
  PIP_CLOSED_MANUALLY: "pip_closed_manually",
  EXPAND_CLICKED: "pip_expand_clicked",
  PIP_FALLBACK_WINDOW: "pip_fallback_window_open",
};

export const isPipSupported = () =>
  typeof window !== "undefined" &&
  "documentPictureInPicture" in window &&
  typeof window.documentPictureInPicture.requestWindow === "function";

export const isPipModeEnabled = () =>
  String(process.env.REACT_APP_ENABLE_PIP_MODE || "").toLowerCase() === "true";
